import { useGo, useTranslate } from "@refinedev/core";
import useDeleteSubscription from "./hooks/useDeleteSubscription";
import { Button, Flex, Popconfirm, Typography } from "antd";
import { useParams } from "react-router-dom";

const SubscriptionCancel: React.FC = () => {
  const t = useTranslate();
  const go = useGo();
  const { id } = useParams();
  const { deleteSubscription } = useDeleteSubscription(id);
  return (
    <Flex vertical gap={15} style={{ width: "50%", margin: "0 auto" }}>
      <Typography.Title>
        {t("pages.subscription.cancel.title")}
      </Typography.Title>
      <Typography.Text>
        {t("pages.subscription.cancel.description")}
      </Typography.Text>
      <Popconfirm
        onConfirm={() => {
          deleteSubscription()
            .then(() => {
              go({ to: "/" });
            })
            .catch(() => {
              // failed to delete the subscription
              // TODO
              // return go({ to: "/oops" });
            });
        }}
        title={t("pages.subscription.cancel.description")}
      >
        <Button size={"large"} type="primary">
          {t("pages.subscription.buttons.cancelSubscription")}
        </Button>
      </Popconfirm>
    </Flex>
  );
};

export default SubscriptionCancel;
